import { useRef } from "react";
import { ThumbsUp, Bell, MessageCircle } from "lucide-react";

const HOLD_MS = 30000;

// End-of-over Like/Subscribe/Comment break: on after the over's last ball, off on next ball, any new graphic, or 30 s.
export function useSocialCta(ctx) {
  const seen = useRef({});
  const on = ctx.onair || {}; const st = ctx.state;
  if (!on.social_cta || !st || st.result || st.current == null) return null;
  const inn = st.innings?.[st.current];
  if (!inn || inn.complete || !inn.balls) return null;
  const played = (inn.overs || []).filter((o) => o.balls?.length);
  const last = played[played.length - 1]; const open = inn.overs?.[inn.overs.length - 1];
  if (!last?.closed || (open !== last && open?.balls?.length)) return null;
  if (String(last.balls[last.balls.length - 1] || "").includes("W")) return null;
  const key = `${st.current}-${last.no}`;
  if (seen.current.key !== key) seen.current = { key, at: Math.min(Date.now(), ctx.published_at ? new Date(ctx.published_at).getTime() : Date.now()), upd: on.updated_at };
  if (seen.current.upd !== on.updated_at || Date.now() - seen.current.at > HOLD_MS) return null;
  const xi = (inn.batting === ctx.match?.team_a ? ctx.match?.xi_a : ctx.match?.xi_b) || [];
  const inHand = Math.max(0, (xi.length || 11) - 1 - inn.wickets);
  return { over: last.no, runs: last.runs, wickets: last.wickets, inHand, team: ctx.teams?.[inn.batting], score: `${inn.runs}/${inn.wickets}`, overs: inn.overs_text };
}

const BTNS = [[ThumbsUp, "Like", "#1877F2"], [Bell, "Subscribe", "#FF0000"], [MessageCircle, "Comment", "#22C55E"]];

export function SocialCta({ s }) {
  return (
    <div className="absolute inset-x-0 bottom-[7%] flex justify-center" data-testid="social-cta">
      <style>{`@keyframes scIn{from{opacity:0;transform:translateY(80px) scale(.9)}to{opacity:1;transform:none}}
@keyframes scBtn{0%{opacity:0;transform:scale(.3)}60%{opacity:1;transform:scale(1.12)}100%{transform:scale(1)}}
@keyframes scPulse{0%,100%{transform:scale(1)}50%{transform:scale(1.07)}}
@keyframes scTap{0%,70%,100%{transform:translate(0,0)}80%{transform:translate(-6px,-6px) scale(.9)}}`}</style>
      <div className="flex items-center gap-10 rounded-[28px] px-12 py-7 text-white shadow-2xl" style={{ background: "var(--c-grad, #0B1530)", animation: "scIn .6s cubic-bezier(.2,.9,.3,1.2) both", fontFamily: "var(--c-font, inherit)" }}>
        <div className="min-w-[300px]">
          <div className="text-[22px] font-bold uppercase tracking-[0.25em] opacity-80" data-testid="social-cta-over">End of over {s.over}</div>
          <div className="text-[54px] font-black leading-none" data-testid="social-cta-score">{s.team?.short || ""} {s.score} <span className="text-[30px] opacity-70">({s.overs})</span></div>
          <div className="mt-2 text-[24px] font-bold" data-testid="social-cta-over-runs">{s.runs} run{s.runs === 1 ? "" : "s"} this over{s.wickets ? ` · ${s.wickets} wkt` : ""}</div>
          {s.inHand > 0 && <div className="mt-1 text-[24px] font-black text-[#FFC233]" data-testid="social-cta-wickets-in-hand">{s.inHand} wicket{s.inHand === 1 ? "" : "s"} in hand</div>}
        </div>
        <div className="flex gap-5">{BTNS.map(([Ic, l, c], k) => (
          <div key={l} className="flex items-center gap-3 rounded-full px-8 py-5 text-[30px] font-black uppercase" style={{ background: c, animation: `scBtn .5s ${0.3 + k * 0.25}s both, scPulse 1.6s ${1.2 + k * 0.3}s infinite` }} data-testid={`social-cta-${l.toLowerCase()}`}>
            <Ic size={38} style={{ animation: `scTap 1.6s ${1.2 + k * 0.3}s infinite` }} /> {l}</div>))}
        </div>
      </div>
    </div>
  );
}
